import { APP_INITIALIZER, inject, Injector } from '@angular/core';
import { environment, partnerId } from '../../../globals';

const importers = {
  prod: {
    OLST: () => import('./olst.service'),
    MIL: () => import('./mil.service'),
  },
};

const factory = () => {
  const injector = inject(Injector);

  return async () => {
    const importer = importers[environment]?.[partnerId];
    if (importer) {
      const m = await importer();
      return injector.get<unknown>(m.default);
    }
  };
};

export const partnerServiceInitializer = {
  provide: APP_INITIALIZER,
  useFactory: factory,
  multi: true,
};
